module.exports = __webpack_public_path__ + "media/components/components/booking/KidsSafety/assets/seat-without-belts-ca32ab23788262504a201e72da7d31e9.svg";